import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const approvePromoteDefaultValues = { reasonForOverriding: '' };

const approvePromoteSchema = yup.object({
  reasonForOverriding: yup.string().required('Reason for overriding is required.')
});

export function useApprovePromoteForm() {
  return useForm<{ reasonForOverriding: string }>({
    mode: 'onSubmit',
    resolver: yupResolver(approvePromoteSchema),
    defaultValues: approvePromoteDefaultValues
  });
}